import React from 'react';
import { connect } from 'react-redux';

import './StartPage.css';

const StartPage = props => {
    const { mainContent } = props;

    const sidebar = document.getElementById('sidebar');
    const navbar_width = sidebar && document.getElementById('sidebar').offsetWidth - 40;
    const mainAreaWidth = window.innerWidth - navbar_width;
    // $('#content').css('margin-left', (Math.max(0, navbar_width - 40)).toString() + 'px')

    return (
        <div className='startPage' style={{width: `${navbar_width}px`}}>
            <div className='startPage-wrapper'>
                <div className='startPage-mainContent' dangerouslySetInnerHTML={{__html: mainContent}} />
            </div>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => ({
    mainContent: ownProps.mainContent
});

export default connect(mapStateToProps)(StartPage)